/* tslint:disable */
/* eslint-disable */
/**
 * seller
 * アグリノート米市場 Seller API
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: mazhulin.d@water-cell.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { Attachment, AttachmentFromJSON, AttachmentFromJSONTyped, AttachmentToJSON } from './'

/**
 * 生産者の住所の共通項目
 * @export
 * @interface ProducerAddressReadSeller
 */
export interface ProducerAddressReadSeller {
  /**
   * ID
   * @type {number}
   * @memberof ProducerAddressReadSeller
   */
  readonly id: number
  /**
   * レコードのバージョン番号
   * @type {number}
   * @memberof ProducerAddressReadSeller
   */
  readonly versionNumber: number
  /**
   * 削除フラグ（true: 削除済、false: 未削除）
   * @type {boolean}
   * @memberof ProducerAddressReadSeller
   */
  readonly isDeleted: boolean
  /**
   * 書き込みは空文字可。
   * 読み込み時に空文字が設定されている場合、住所を整形した値を自動的に返す。
   * @type {string}
   * @memberof ProducerAddressReadSeller
   */
  name: string
  /**
   * 都道府県のID、海外は含まない
   * @type {number}
   * @memberof ProducerAddressReadSeller
   */
  prefectureId: number
  /**
   *
   * @type {string}
   * @memberof ProducerAddressReadSeller
   */
  city: string
  /**
   *
   * @type {string}
   * @memberof ProducerAddressReadSeller
   */
  address1: string
  /**
   * 空文字可
   * @type {string}
   * @memberof ProducerAddressReadSeller
   */
  address2: string
  /**
   * 進入可能な最大車種（"trailer_20t": トレーラー(20t), "truck_12t": トラック(12t), "truck_8t": トラック(8t), "truck_4t": トラック(4t), "truck_2t": トラック(2t), "kei_truck": 軽トラのみ, "not_allowed": トラック乗り入れ不可）
   * @type {string}
   * @memberof ProducerAddressReadSeller
   */
  maxPassableVehicleType: ProducerAddressReadSellerMaxPassableVehicleTypeEnum
  /**
   * 土日・祝日引取可否（"sat_sun_hol_ok": 土日・祝日共に可, "sat_only": 土曜日のみ可, "sun_only": 日曜日のみ可,  "sat_sun_only": 土日のみ可・祝日は不可, "hol_only": 祝日のみ可, "sat_sun_hol_ng": 土日・祝日共に不可, "others": その他）
   * @type {string}
   * @memberof ProducerAddressReadSeller
   */
  holidayAvailability: ProducerAddressReadSellerHolidayAvailabilityEnum
  /**
   *
   * @type {string}
   * @memberof ProducerAddressReadSeller
   */
  holidayAvailabilityOthers: string | null
  /**
   *
   * @type {string}
   * @memberof ProducerAddressReadSeller
   */
  staffNameKana: string
  /**
   * 携帯電話か固定電話
   * @type {string}
   * @memberof ProducerAddressReadSeller
   */
  tel: string
  /**
   * 空文字可
   * @type {string}
   * @memberof ProducerAddressReadSeller
   */
  memo: string
  /**
   *
   * @type {string}
   * @memberof ProducerAddressReadSeller
   */
  cautionsDuringRain: string
  /**
   * 添付ファイル一覧。配列順を表示順とする。
   * @type {Array<Attachment>}
   * @memberof ProducerAddressReadSeller
   */
  readonly photoAttachments: Array<Attachment>
}

/**
 * @export
 * @enum {string}
 */
export enum ProducerAddressReadSellerMaxPassableVehicleTypeEnum {
  Trailer20t = 'trailer_20t',
  Truck12t = 'truck_12t',
  Truck8t = 'truck_8t',
  Truck4t = 'truck_4t',
  Truck2t = 'truck_2t',
  KeiTruck = 'kei_truck',
  NotAllowed = 'not_allowed',
}
/**
 * @export
 * @enum {string}
 */
export enum ProducerAddressReadSellerHolidayAvailabilityEnum {
  SatSunHolOk = 'sat_sun_hol_ok',
  SatOnly = 'sat_only',
  SunOnly = 'sun_only',
  SatSunOnly = 'sat_sun_only',
  HolOnly = 'hol_only',
  SatSunHolNg = 'sat_sun_hol_ng',
  Others = 'others',
}

export function ProducerAddressReadSellerFromJSON(json: any): ProducerAddressReadSeller {
  return ProducerAddressReadSellerFromJSONTyped(json, false)
}

export function ProducerAddressReadSellerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProducerAddressReadSeller {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    versionNumber: json['version_number'],
    isDeleted: json['is_deleted'],
    name: json['name'],
    prefectureId: json['prefecture_id'],
    city: json['city'],
    address1: json['address_1'],
    address2: json['address_2'],
    maxPassableVehicleType: json['max_passable_vehicle_type'],
    holidayAvailability: json['holiday_availability'],
    holidayAvailabilityOthers: json['holiday_availability_others'],
    staffNameKana: json['staff_name_kana'],
    tel: json['tel'],
    memo: json['memo'],
    cautionsDuringRain: json['cautions_during_rain'],
    photoAttachments: (json['photo_attachments'] as Array<any>).map(AttachmentFromJSON),
  }
}

export function ProducerAddressReadSellerToJSON(value?: ProducerAddressReadSeller | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    prefecture_id: value.prefectureId,
    city: value.city,
    address_1: value.address1,
    address_2: value.address2,
    max_passable_vehicle_type: value.maxPassableVehicleType,
    holiday_availability: value.holidayAvailability,
    holiday_availability_others: value.holidayAvailabilityOthers,
    staff_name_kana: value.staffNameKana,
    tel: value.tel,
    memo: value.memo,
    cautions_during_rain: value.cautionsDuringRain,
  }
}
